import { useState } from "react";
import {
  downloadAlwaysOnInstaller,
  downloadAlwaysOnUninstaller,
} from "../lib/alwaysOn";

type Props = {
  alwaysOn: boolean;
  liveOn: boolean;
  onToggle: (on: boolean) => void;
};

export function AlwaysOnCard({ alwaysOn, liveOn, onToggle }: Props) {
  const [useLocal, setUseLocal] = useState(false);
  const local =
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

  return (
    <section className="vf-card">
      <div className="vf-label">Always on</div>
      <div className="vf-cost-hint" style={{ marginBottom: 8 }}>
        Camera stays live and keeps firing mappings. Pair with Windows startup so Live
        opens at login.
      </div>
      <label className="vf-binding" style={{ cursor: "pointer" }}>
        <input
          type="checkbox"
          checked={alwaysOn}
          onChange={(e) => onToggle(e.target.checked)}
        />
        <div className="vf-binding-meta">
          <div className="vf-binding-gesture">
            {alwaysOn ? "Always on" : "Always on — off"}
          </div>
          <div className="vf-binding-hint">
            {alwaysOn
              ? liveOn
                ? "Listening. Switching tabs keeps the camera."
                : "Will start the camera."
              : "Start camera only when you click Start."}
          </div>
        </div>
      </label>
      <div className="vf-row" style={{ marginTop: 8 }}>
        <button
          type="button"
          className="vf-chip"
          onClick={() => downloadAlwaysOnInstaller(useLocal)}
        >
          Start with Windows
        </button>
        <button type="button" className="vf-chip" onClick={downloadAlwaysOnUninstaller}>
          Remove startup
        </button>
      </div>
      {local && (
        <label className="vf-binding" style={{ marginTop: 6, cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={useLocal}
            onChange={(e) => setUseLocal(e.target.checked)}
          />
          <div className="vf-binding-meta">
            <div className="vf-binding-hint">
              Helper opens this local URL (dev only — production is used by default)
            </div>
          </div>
        </label>
      )}
      <div className="vf-binding-hint" style={{ marginTop: 6 }}>
        Double-click the downloaded <code>.vbs</code> once. It copies itself into Startup
        and opens an app window. Windows will ask for the camera the first time.
      </div>
    </section>
  );
}
